exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".basicModal.footer{height:52px;background-color:#f7f7f7;padding:8px;color:#333;border-top:1px solid #ddd;border-bottom-left-radius:2px;border-bottom-right-radius:2px}.basicModal.tall{height:68px}", ""]);

// exports
